/* ============================================================
   Buy-box marketplace (plantilla producto 3 columnas)
   1) Espeja el precio vivo dentro de la card sticky SIN tocar la
      lógica del tema: empire.js sigue actualizando el nodo original
      [data-product-pricing]; aquí solo copiamos su HTML a la card.
   2) Calcula el offset sticky de la card según la altura REAL del
      header (que es sticky → tapa la card si no se compensa). Se
      recalcula al hacer scroll porque el header se colapsa.
   ============================================================ */
(function () {
  if (window.__ttBuybox) return;
  window.__ttBuybox = true;

  function getWrap() {
    return document.querySelector('[data-product-wrapper].layout--three-col')
        || document.querySelector('.layout--three-col');
  }

  // ---- 1) Espejo de precio (card desktop + barra móvil) -----------------
  function initMirror() {
    var wrap = getWrap();
    if (!wrap) return;

    var src = wrap.querySelector('[data-product-pricing]');
    if (!src) return;

    var dsts = [
      wrap.querySelector('[data-tt-buybox-price]'),
      wrap.querySelector('[data-tt-mbar-price]')
    ].filter(Boolean);
    if (!dsts.length) return;

    var sync = function () {
      var html = src.innerHTML;
      for (var i = 0; i < dsts.length; i++) dsts[i].innerHTML = html;
    };
    sync();

    // empire.js reemplaza el innerHTML del precio al cambiar de variante.
    var mo = new MutationObserver(sync);
    mo.observe(src, { childList: true, subtree: true, characterData: true });
  }

  // ---- 4) Barra de compra fija en móvil ---------------------------------
  // El botón de la barra dispara el ATC REAL del formulario (delegamos toda
  // la lógica del tema: validación de variante, /cart/add, y el cart drawer
  // que ya intercepta el add). Refleja el estado agotado del botón real.
  function initMobileBar() {
    var wrap = getWrap();
    if (!wrap) return;

    var bar = wrap.querySelector('[data-tt-mbar]') || document.querySelector('[data-tt-mbar]');
    if (!bar) return;
    var barBtn = bar.querySelector('[data-tt-mbar-add]');
    if (!barBtn) return;

    function realBtn() {
      // El "Añadir al carrito" real es el que tiene data-product-atc (type=submit).
      // El otro .product-form--atc-button (teal) es "Comprar ahora" → NO usar.
      return wrap.querySelector('[data-product-form-regular] [data-product-atc]')
          || wrap.querySelector('form[data-product-form] [data-product-atc]')
          || wrap.querySelector('[data-product-form-regular] .product-form--atc-button');
    }

    barBtn.addEventListener('click', function () {
      var b = realBtn();
      if (b) b.click();
    });

    function syncState() {
      var b = realBtn();
      if (!b) return;
      var disabled = b.disabled || b.classList.contains('disabled');
      barBtn.disabled = !!disabled;
      barBtn.textContent = disabled ? 'Sin stock' : 'Añadir';
    }
    syncState();

    // Al cambiar variante, empire re-renderiza el form → re-sincronizar estado.
    var formArea = wrap.querySelector('[data-product-form-regular]');
    if (formArea && 'MutationObserver' in window) {
      new MutationObserver(syncState).observe(formArea, {
        childList: true, subtree: true, attributes: true
      });
    }
  }

  // ---- 2) Offset sticky = altura del header sticky + respiro ------------
  function initStickyOffset() {
    // El elemento realmente pegado (position:sticky) es .site-header.
    var header = document.querySelector('.site-header-sticky .site-header')
              || document.querySelector('.site-header');
    if (!header) return;

    var GAP = 16; // respiro entre header y card
    var raf = 0;

    function measure() {
      raf = 0;
      var h = Math.round(header.getBoundingClientRect().height);
      if (h > 0) {
        document.documentElement.style.setProperty('--tt-buybox-top', (h + GAP) + 'px');
      }
    }
    function schedule() {
      if (!raf) raf = window.requestAnimationFrame(measure);
    }

    measure();
    window.addEventListener('resize', schedule, { passive: true });
    // El header se colapsa al scrollear (estado --scrolled) → re-medir.
    window.addEventListener('scroll', schedule, { passive: true });
  }

  // ---- 3) Recalcular la galería tras aplicar el grid --------------------
  // empire.js fija la altura del visor (viewer.style.height) midiendo la
  // imagen seleccionada. Como nuestro grid cambia el ancho de la galería
  // DESPUÉS de que empire ya midió (CSS externo cargado al final del body),
  // la altura queda desfasada → imagen recortada / con hueco. empire escucha
  // 'resize' y recalcula, así que le damos un empujón cuando el layout ya
  // está aplicado y cuando terminan de cargar imágenes.
  function nudgeGallery() {
    if (!document.querySelector('.layout--three-col .product-gallery--viewer')) return;
    try { window.dispatchEvent(new Event('resize')); }
    catch (e) {
      var ev = document.createEvent('Event');
      ev.initEvent('resize', true, true);
      window.dispatchEvent(ev);
    }
  }

  function init() {
    initMirror();
    initStickyOffset();
    initMobileBar();

    // Un empuje cuando el layout ya se resolvió...
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(nudgeGallery);
    });
    // ...y otro cuando todo (CSS + imágenes) terminó de cargar.
    if (document.readyState === 'complete') {
      nudgeGallery();
    } else {
      window.addEventListener('load', nudgeGallery, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
